import React, { useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { Feather } from '@expo/vector-icons'
import { Answer, QuestionOptionSelectedText } from '../../interfaces/FieldAssesment.interface'
import styles from './SinoNaIEditItemStyles'
import theme from '../../../../../theme'

interface SinoNaIEditItemI {
    item: Answer
}

export const SinoNaIEditItem = ({ item }: SinoNaIEditItemI) => {
    const [itemSelected, setitemSelected] = useState(item)

    return (
        <View>
            <View style={styles.containerItem}>
                <View style={{ flex: 8 }}>
                    {item.question && <Text style={styles.title}>{item.question}</Text>}
                    {item.description && <Text style={styles.description}>{item.description}</Text>}
                </View>

                <View style={{ flex: 1, marginHorizontal: 6 }}>
                    <View style={styles.flexDirectionRow}>
                        {itemSelected.questionOptionSelectedText[0] === QuestionOptionSelectedText.Yes && (
                            <Feather name='check' size={32} color={theme.colors.colorApproved} />
                        )}
                        {itemSelected.questionOptionSelectedText[0] === QuestionOptionSelectedText.No && (
                            <Feather name='x' size={32} color={theme.colors.colorDisapproved} />
                        )}
                    </View>
                </View>
            </View>
            <View style={styles.spacer1}></View>
            <View style={styles.divider}></View>
            <View style={styles.spacer1}></View>
        </View>
    )
}
